import { registerFlow } from '../../../core/flow-register';
import FlowHeader from '../../../components/FlowHeader/FlowHeader';
import FooterSite from '../../../components/FooterSite/FooterSite';
import BaseLayout from '../../../components/BaseLayout/BaseLayout';
import InternalAuthenticator from '../../../components/BaseLayout/InternalAuthenticator';
import SummitRewards from '../../../components/BaseLayout/SummitRewards';
import AddressValidationModal from '../../../components/AddressValidationModal/AddressValidationModal';
import CredentialsValidationModal from '../../../components/CredentialsValidationModal/CredentialsValidationModal';
import FONASUMFTaxableJointScreen from '../../../screens/FONASUMFTaxableJointScreen/FONASUMFTaxableJointScreen';
import { FlowNode } from '../../../core/types/flow';
import { contactTextFn, updateFONASUAnalytics } from '../../shared/utils';

import { finish, openModal } from '../../../core/actions';
import {
  isValidSSN,
  isValidDob,
  usernameValidation,
  meetsTaxableMinimumInvestment,
  isUsernameAlreadyTaken,
  isUsernameCreationFailed,
  isTempPasswordCreationFailed,
  chosenAddressValidation
} from '../../shared/testers';
import { makeLoadTaxableData } from './loaders';
import { createFONASUApplication } from '../shared/loaders';

const nodes: Array<FlowNode> = [
  {
    route: 'fonasuMFTaxableJoint',
    screen: FONASUMFTaxableJointScreen,
    load: makeLoadTaxableData,
    commit: createFONASUApplication,
    form: [
      { name: 'firstName', required: true },
      { name: 'lastName', required: true },
      { name: 'middleName' },
      { name: 'dob', required: true, validation: isValidDob },
      { name: 'citizenship', required: true },
      { name: 'ssn', required: true, validation: isValidSSN },
      {
        name: 'amount',
        required: true,
        validation: meetsTaxableMinimumInvestment
      },
      { name: 'residentialStreet1', required: true },
      { name: 'residentialStreet2' },
      { name: 'residentialZip', required: true },
      { name: 'residentialCity', required: true },
      { name: 'residentialState', required: true },
      { name: 'mailingStreet1', required: true },
      { name: 'mailingStreet2' },
      { name: 'mailingZip', required: true },
      { name: 'mailingCity', required: true },
      { name: 'mailingState', required: true },
      { name: 'primaryEmailAddress', required: true },
      { name: 'phone1', required: true },
      { name: 'phone2' },
      { name: 'phone3' },
      { name: 'mailingAddressDifferent', type: 'checkbox' },
      { name: 'useResidentialAddress', required: true },
      { name: 'useMailingAddress', required: true },
      { name: 'jointOwnerFirstName', required: true },
      { name: 'jointOwnerMiddleName' },
      { name: 'jointOwnerLastName', required: true },
      { name: 'jointOwnerDob', required: true, validation: isValidDob },
      { name: 'jointOwnerCitizenship', required: true },
      {
        name: 'jointOwnerSsn',
        required: true,
        validation: isValidSSN
      },
      { name: 'jointOwnerSameAddress', type: 'checkbox' },
      { name: 'jointOwnerResidentialStreet1', required: true },
      { name: 'jointOwnerResidentialStreet2' },
      { name: 'jointOwnerResidentialZip', required: true },
      { name: 'jointOwnerResidentialCity', required: true },
      { name: 'jointOwnerResidentialState', required: true },
      {
        name: 'username',
        validation: usernameValidation
      },
      {
        name: 'password'
      }
    ],
    next: {
      cases: [
        [chosenAddressValidation, openModal(AddressValidationModal)],
        [isUsernameAlreadyTaken, openModal(CredentialsValidationModal)],
        [isTempPasswordCreationFailed, openModal(CredentialsValidationModal)],
        [isUsernameCreationFailed, openModal(CredentialsValidationModal)]
      ],
      default: finish()
    },
    flowProps: {
      analytics: {
        pageName: 'FONASUTaxableJoint'
      }
    }
  }
];

export default registerFlow({
  namespace: 'front-office/mutual-fund/taxable/joint',
  nodes,
  start: 'fonasuMFTaxableJoint',
  pageDecorators: [BaseLayout, InternalAuthenticator, SummitRewards],
  onLoad: updateFONASUAnalytics,
  flowProps: {
    getContactText: contactTextFn(),
    header: FlowHeader,
    footer: FooterSite
  }
});
